export const styles = (theme) =>({
  btnStatus: {
    width: "6rem",
    minWidth: 80,
    fontSize: "0.675rem",
  },
})